import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'class-pass',
  template: `
    <div *ngIf="hasClassPass;else dash" class="flex align-items-center">
    <img src="/assets/img/classpass_compact.svg" alt="ClassPass booking" class="w-8rem h-3rem" />
    </div>
    <ng-template #dash>
      <div class="flex align-items-center">
        <span>-</span>
      </div>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class ClassPassComponent implements OnInit {

  @Input() columnData = new BehaviorSubject(null);
  @Input() keyName = new BehaviorSubject(null);

  hasClassPass = false;


  ngOnInit(): void {
    this.columnData.subscribe((data:any) => {
      this.hasClassPass =  data.cp_booking == '1';
    });
  }

}
